import React, { memo, useEffect, useMemo } from "react";

import { Form, Input, Typography } from "antd";
import PropTypes from "prop-types";
import { IoStar } from "react-icons/io5";

import { useAppTheme } from "../../../context/ThemeProvider";
import FormItemWithImageUploader from "./FormItemWithImageUploader";

const ReviewKYCForm = ({
  kyc,
  // isModalOpen,
  requiredDocuments,
  formMode,
  authority,
  rejectionReasons,
  onAddRejectionReason,
}) => {
  const { COLORS } = useAppTheme();

  const [form] = Form.useForm();

  const initialFormValues = useMemo(
    () => ({
      pan: kyc?.pan?.number || "",
      panFrontImage: kyc?.pan?.frontImage || "",
      panRearImage: kyc?.pan?.rearImage || "",

      authorisedSignatoryPan: kyc?.authorisedSignatoryPan?.number || "",
      authorisedSignatoryPanFrontImage:
        kyc?.authorisedSignatoryPan?.frontImage || "",
      authorisedSignatoryPanRearImage:
        kyc?.authorisedSignatoryPan?.rearImage || "",

      aadhar: kyc?.aadhar?.number || "",
      aadharFrontImage: kyc?.aadhar?.frontImage || "",
      aadharRearImage: kyc?.aadhar?.rearImage || "",

      authorisedSignatoryAadhar: kyc?.authorisedSignatoryAadhar?.number || "",
      authorisedSignatoryAadharFrontImage:
        kyc?.authorisedSignatoryAadhar?.frontImage || "",
      authorisedSignatoryAadharRearImage:
        kyc?.authorisedSignatoryAadhar?.rearImage || "",

      passport: kyc?.passport?.number || "",
      passportFrontImage: kyc?.passport?.frontImage || "",
      passportRearImage: kyc?.passport?.rearImage || "",

      authorisedSignatoryPassport:
        kyc?.authorisedSignatoryPassport?.number || "",
      authorisedSignatoryPassportFrontImage:
        kyc?.authorisedSignatoryPassport?.frontImage || "",
      authorisedSignatoryPassportRearImage:
        kyc?.authorisedSignatoryPassport?.rearImage || "",

      residencyFrontImage: kyc?.residency?.frontImage || "",
      authorisedSignatoryResidencyFrontImage:
        kyc?.authorisedSignatoryResidency?.frontImage || "",

      certificateOfIncorporationFrontImage:
        kyc?.certificateOfIncorporation?.frontImage || "",

      gstCertificate: kyc?.gstCertificate?.number || "",
      gstCertificateFrontImage: kyc?.gstCertificate?.frontImage || "",
    }),
    [kyc]
  );

  useEffect(() => {
    form.setFieldsValue(initialFormValues);
  }, [initialFormValues]);

  return (
    <Form
      layout="vertical"
      form={form}
      initialValues={initialFormValues}
      style={{
        maxHeight: "calc(100vh - 225px)",
        overflowX: "hidden",
        overflowY: "auto",
      }}
      className="review-kyc-form slimScroll"
    >
      <div className="review-kyc-form__wrapper">
        <div
          className="form-item-with-uploader"
          style={{
            gridColumn: "1 / span 2",
          }}
        >
          <Typography.Title
            level={5}
            className="title"
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            KYC Type
            <IoStar
              style={{
                fontSize: 10,
                color: COLORS.ERROR,
                marginLeft: 4,
              }}
            />
          </Typography.Title>

          <Typography.Paragraph className="subtitle">
            Documents will be asked to submit based on the selected KYC type.
          </Typography.Paragraph>

          <Input
            size="large"
            value={kyc?.authority?.toTitleCase()}
            readOnly
            style={{ width: "100%" }}
          />
        </div>

        {requiredDocuments.map((documentType) => (
          <FormItemWithImageUploader
            key={documentType}
            kyc={kyc}
            title={
              (formMode === "IN" &&
                authority === "company" &&
                ((documentType === "pan" && "Company PAN Card") ||
                  (documentType === "authorisedSignatoryPan" &&
                    "Owner PAN Card"))) ||
              undefined
            }
            inputName={documentType}
            documentType={documentType}
            enableNumberInput={
              [
                "residency",
                "authorisedSignatoryResidency",
                "certificateOfIncorporation",
              ].includes(documentType) === false
            }
            required={documentType !== "gstCertificate"}
            sides={["front"]}
            rejectionReason={rejectionReasons?.[documentType]}
            onAddRejectionReason={(reason) =>
              onAddRejectionReason(documentType, reason)
            }
          />
        ))}
      </div>
    </Form>
  );
};

ReviewKYCForm.propTypes = {
  kyc: PropTypes.shape().isRequired,
  // isModalOpen: PropTypes.bool.isRequired,
  requiredDocuments: PropTypes.arrayOf(PropTypes.string).isRequired,
  formMode: PropTypes.string.isRequired,
  authority: PropTypes.string.isRequired,
  rejectionReasons: PropTypes.string.isRequired,
  onAddRejectionReason: PropTypes.func.isRequired,
};

export default memo(ReviewKYCForm);
